module.exports = __webpack_public_path__ + "img/demo-artwork.4dec2910.png";